import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "./UserContext"; // Import UserContext
import { Accordion, Card, useAccordionButton } from "react-bootstrap";
import { FaHome, FaChevronDown, FaChevronUp } from "react-icons/fa"; // Import icons from react-icons
import { FaPeopleGroup, FaGraduationCap, FaComments } from "react-icons/fa6";
import { FaTasks, FaBirthdayCake } from "react-icons/fa";
import { PiHandWavingLight } from "react-icons/pi";
import { MdAdminPanelSettings } from "react-icons/md";

import { MdOutlineQrCode2 } from "react-icons/md";

import { FaDownload } from "react-icons/fa";
import { IoPeopleSharp } from "react-icons/io5";

import { IoMdSchool } from "react-icons/io";
import { LuPartyPopper } from "react-icons/lu";
import { AiFillAlert } from "react-icons/ai";

const data = {
  "Panel de Control": [
    {
      name: "Panel de Control",
      url: "/",
      icon: <FaHome />,
      color: "black",
      roles: ["*"],
    },
    {
      name: "Administración",
      url: "/admin/",
      icon: <MdAdminPanelSettings />,
      color: "black",
      roles: ["*"],
    },
    {
      name: "Generar QR",
      url: "/api/generar_qr/",
      icon: <MdOutlineQrCode2 />,
      color: "black",
      roles: ["*"],
    },
  ],

  "Gestión de Comunidades": {
    icon: <FaPeopleGroup />,
    items: [
      {
        name: "Tabla Maestras de la Comunidad",
        url: "/maestras",
        icon: <FaGraduationCap />,
        color: "#9B00D6",
        roles: ["*"],
      },
      {
        name: "Tabla de Cursos y Programas",
        url: "/cursos",
        icon: <FaTasks />,
        color: "#17a2b8",
        roles: ["*"],
      },
      {
        name: "Tabla de Otras Actividades",
        url: "/actividades",
        icon: <FaTasks />,
        color: "#D6A400",
        roles: ["*"],
      },
      {
        name: "Lista de Comentarios Recientes",
        url: "/comentarios",
        icon: <FaComments />,
        color: "#dc3545",
        roles: ["*"],
      },
      {
        name: "Solicitudes Comunidad",
        url: "/solicitudes",
        icon: <PiHandWavingLight />,
        color: "#28a745",
        roles: ["*"],
      },
      {
        name: "Cumpleaños Mes Actual",
        url: "/cumpleaños",
        icon: <FaBirthdayCake />,
        color: "#fd7e14",
        roles: ["*"],
      },
    ],
  },

  Descargas: {
    icon: <FaDownload />,
    items: [
      {
        name: "Excel Maestras",
        url: "/api/perfiles/maestras/?excel=true",
        icon: <IoPeopleSharp />,
        color: "#9B00D6",
        roles: ["Fundadora", "Comunidades", "Soporte"],
      },
      {
        name: "Excel Cursos",
        url: "/api/perfiles/cursos/?excel=true",
        icon: <IoMdSchool />,
        color: "#28a745",
        roles: ["Fundadora", "Comunidades", "Soporte"],
      },
      {
        name: "Excel Actividades",
        url: "/api/perfiles/actividades/?excel=true",
        icon: <LuPartyPopper />,
        color: "#17a2b8",
        roles: ["Fundadora", "Comunidades", "Soporte"],
      },
      {
        name: "Excel Interesadas",
        url: "/api/formularios/comunidades/?excel=true",
        icon: <AiFillAlert />,
        color: "red",
        roles: ["Fundadora", "Comunidades", "Soporte"],
      },
    ],
  },

  Desarrollador: {
    icon: <FaDownload />,
    items: [
      {
        name: "Actualizar Whatsapp",
        url: "/whatsapp",
        icon: <IoPeopleSharp />,
        color: "#9B00D6",
        roles: ["Soporte"],
      },
    ],
  },
};

function CustomToggle({ children, eventKey, callback }) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    callback(eventKey),
  );

  return (
    <div
      onClick={decoratedOnClick}
      style={{
        cursor: "pointer",
        fontWeight: "bold",
        padding: "10px 0",
        display: "flex",
        alignItems: "center",
      }}
    >
      {children}
    </div>
  );
}

function Indice({ handleOffcanvasToggle }) {
  const [activeEventKey, setActiveEventKey] = useState(null);
  const { roles } = useContext(UserContext); // Access roles from UserContext

  const handleToggle = (eventKey) => {
    setActiveEventKey(activeEventKey === eventKey ? null : eventKey);
  };

  const hasRole = (requiredRoles) => {
    if (requiredRoles.includes("*")) return true; // '*' means everyone can view
    return roles.some((role) => requiredRoles.includes(role));
  };

  return (
    <div id="Indice">
      {hasRole(data["Panel de Control"][0].roles) && (
        <div className="Lonely-Index">
          <Link
            to={data["Panel de Control"][0].url}
            onClick={handleOffcanvasToggle}
            style={{
              textDecoration: "none",
              color: data["Panel de Control"][0].color,
              display: "flex",
              alignItems: "center",
            }}
          >
            {data["Panel de Control"][0].icon}{" "}
            <span style={{ marginLeft: "10px" }}>
              {data["Panel de Control"][0].name}
            </span>
          </Link>
        </div>
      )}

      {hasRole(data["Panel de Control"][1].roles) && (
        <div className="Lonely-Index">
          <a
            href={data["Panel de Control"][1].url} // Use <a> instead of <Link> for external URL
            style={{
              textDecoration: "none",
              color: data["Panel de Control"][1].color,
              display: "flex",
              alignItems: "center",
            }}
          >
            {data["Panel de Control"][1].icon}{" "}
            <span style={{ marginLeft: "10px" }}>
              {data["Panel de Control"][1].name}
            </span>
          </a>
        </div>
      )}

      {hasRole(data["Panel de Control"][2].roles) && (
        <div className="Lonely-Index">
          <a
            href={data["Panel de Control"][2].url} // Use <a> instead of <Link> for external URL
            style={{
              textDecoration: "none",
              color: data["Panel de Control"][2].color,
              display: "flex",
              alignItems: "center",
            }}
          >
            {data["Panel de Control"][2].icon}{" "}
            <span style={{ marginLeft: "10px" }}>
              {data["Panel de Control"][2].name}
            </span>
          </a>
        </div>
      )}

      <Accordion>
        {Object.keys(data)
          .filter((key) => key !== "Panel de Control")
          .map((title, index) => {
            // Check if user has access to any item within the section
            const visibleItems = data[title].items.filter((item) =>
              hasRole(item.roles),
            );
            if (visibleItems.length === 0) {
              return null; // Skip section if no visible items
            }

            return (
              <Card key={index}>
                <Card.Header>
                  <CustomToggle
                    eventKey={index.toString()}
                    callback={handleToggle}
                  >
                    <span style={{ marginRight: "10px" }}>
                      {data[title].icon}
                    </span>{" "}
                    {title}
                    {activeEventKey === index.toString() ? (
                      <FaChevronUp style={{ marginLeft: "auto" }} />
                    ) : (
                      <FaChevronDown style={{ marginLeft: "auto" }} />
                    )}
                  </CustomToggle>
                </Card.Header>
                <Accordion.Collapse eventKey={index.toString()}>
                  <Card.Body>
                    {visibleItems.map((item, subIndex) => (
                      <div
                        key={subIndex}
                        style={{
                          padding: "5px 0",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{ marginRight: "10px", color: item.color }}
                        >
                          {item.icon}
                        </span>
                        {item.url.startsWith("/admin") ||
                        item.url.startsWith("/api") ? (
                          <a
                            href={item.url} // External admin URL
                            style={{ textDecoration: "none" }}
                          >
                            {item.name}
                          </a>
                        ) : (
                          <Link
                            to={item.url} // Internal React URL
                            onClick={handleOffcanvasToggle}
                            style={{ textDecoration: "none" }}
                          >
                            {item.name}
                          </Link>
                        )}
                      </div>
                    ))}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            );
          })}
      </Accordion>
    </div>
  );
}

export default Indice;
